import { useMutation } from '@tanstack/react-query'

import { ChangePacketResponseCustomerPayload } from '@/types/packet-response'

import { invalidateLoadResponses } from '../responses/useLoadResponse'
import { changePacketResponseCustomer } from './services/changePacketResponseCustomer'

export const useChangePacketResponseCustomer = () => {
  const mutation = useMutation<
    void,
    Error,
    { packetResponseId: string; data: ChangePacketResponseCustomerPayload }
  >({
    mutationFn: async ({ packetResponseId, data }) =>
      changePacketResponseCustomer(packetResponseId, data),
    onSuccess: () => invalidateLoadResponses(),
  })

  const changePacketResponseCustomerReq = async (
    packetResponseId: string,
    data: ChangePacketResponseCustomerPayload
  ) => {
    return mutation.mutateAsync({ packetResponseId, data })
  }

  return {
    changePacketResponseCustomer: changePacketResponseCustomerReq,
    ...mutation,
  }
}
